import * as Types from '../../generated/types';

import gql from 'graphql-tag';
export type ICurrentUserContextUserFragment = { __typename?: 'User', id: string, inactive: boolean, firstName: string, lastName: string, recipientId?: string | null, restrictedDetails?: { __typename?: 'UserRestrictedDetails', email: string, rolesInfo?: { __typename?: 'UserRolesInfo', role?: Types.IUserRole | null } | null } | null };

export const CurrentUserContextUserFragmentDoc = gql`
    fragment CurrentUserContextUser on User {
  id
  inactive
  firstName
  lastName
  recipientId
  restrictedDetails {
    email
    rolesInfo {
      role
    }
  }
}
    `;